export default __webpack_public_path__ + "static/media/a_01.edd53098.jpg";